module.exports = __webpack_public_path__ + "img/Ladjadj.e135aaf1.jpg";